/// <reference path="../../../../_Ext/Bases/GridBase.ts" />
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    export class AdvanceSelectGrid extends _Ext.GridBase<Retail.ReceiptRow, any> {
        protected getColumnsKey() { return 'Common.AdvanceSelect'; }
        protected getDialogType() { return Retail.ReceiptDialog; }
        protected getIdProperty() { return Retail.ReceiptRow.idProperty; }
        protected getInsertPermission() { return Retail.ReceiptRow.insertPermission; }
        protected getLocalTextPrefix() { return Retail.ReceiptRow.localTextPrefix; }
        protected getService() { return Retail.ReceiptSelectService.baseUrl; } 
        protected getInitialTitle() { return null; };
        private autoSize;


        
        constructor(container: JQuery, options) {
            super(container);
            var transids = options.GridFilters.TransIds;
            var customerid= options.GridFilters.CustomerId;
            (this.view.params as TransactionRequest).POSCustomerId = customerid;
            (this.view.params as TransactionRequest).TransIds = transids; 
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
        }
         
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);

            return grid;
        }


        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        get selectedItems(): Retail.ReceiptRow[] {
            var _this = this;
            var c = this.rowSelection.getSelectedAsInt32();
            //.map(function (x) { return _this.view.getItemById(x); });
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };

        protected onViewSubmit() {
            if (!super.onViewSubmit.call(this))
                return false;
             

            return true;

        }
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}